import { render, staticRenderFns } from "./AffiliateModal.vue?vue&type=template&id=a7ea18f4&"
import script from "./AffiliateModal.vue?vue&type=script&lang=js&"
export * from "./AffiliateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports